import s from "styled-components";

export const Wrap = s.div`
  display: flex;
  flex-direction: column;
  max-height: 100%;
  padding-5px;
  padding-bottom: 5px;
  overflow-y: auto;
  ::-webkit-scrollbar-track {
    background-color: white;
    border-radius: 45px;
  }
  ::-webkit-scrollbar {
    width: 5px;
    background-color: #fff;
    border-radius: 45px;
  }
  ::-webkit-scrollbar-thumb {
    background-image: var(--grad-primary-n);
    border-radius: 45px;
  }
`;
export const CounterWrap = s.div`
  display: flex;
  padding: 15px; 
  > div:first-child {
    margin-left: 0;
  }
`;

export const ParticipantsWrap = s.div`
  padding: 15px;
  padding-top: 10px;
`;
export const Participants = s.div`
  border-bottom: ${({ theme }) => theme.border.light};
  padding: 0 10px;;
`;
export const Desc = s.p`
  word-wrap: break-word;
  padding: 0 10px;
  margin-bottom: 0;
  color: var(--font-color-main);
`;
export const Participant = s.div`
  display: flex; 
  align-items: center;
  margin-bottom: 5px;
  a {
    line-height: 0;
  }
`;
export const StatusBadge = s.div`
  margin-left: 5px;
  border-radius: 4px;
  font-size: 14px;
  background: var(--color-primary);
  padding: 5px 10px;
  font-weight: 500;
  color: white;
`;
export const Service = s.div`
  margin-top: 15px;
  color: var(--font-color-emp);
  font-weight: 500;  
  padding: 0 10px;
  > span {
    margin-left: 5px;
  }
`;
